import React from 'react'
import { LoggedHeader } from '../Headers'
import SideBar from '../SideBar'
import { Wrap } from './styles'

const DefaultAdminPage = ({ children, page }) => {
  return (
    <>
      <LoggedHeader />
      <SideBar path={page} />
      <Wrap>{children}</Wrap>
    </>
  )
}

export default DefaultAdminPage
